const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('pages/Index.vue'),
        redirect: { name: 'InstitutionIndex' },
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/authentication',
        name: 'UserAuthentication',
        component: () => import('pages/Authentication.vue'),
      },
      {
        path: '/institutions',
        name: 'InstitutionIndex',
        component: () => import('pages/institution/Index.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/institutions/create',
        name: 'InstitutionCreate',
        component: () => import('pages/institution/Create.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/institutions/edit/:id',
        name: 'InstitutionEdit',
        component: () => import('pages/institution/Edit.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/settings',
        name: 'LocationSettings',
        component: () => import('pages/Settings.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },

      {
        path: '/waste/transfers',
        name: 'WasteTransfers',
        component: () => import('pages/waste/Transfers.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/waste/users',
        name: 'WasteUsers',
        component: () => import('pages/waste/users/Index.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/waste/users/:id',
        name: 'WasteViewUser',
        component: () => import('pages/waste/users/View.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/waste/properties',
        name: 'WasteProperty',
        component: () => import('pages/waste/properties/Index.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/waste/properties/:id',
        name: 'WasteViewProperty',
        component: () => import('pages/waste/properties/View.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/waste/credits',
        name: 'WasteCredits',
        component: () => import('pages/waste/Credits.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },

  {
    path: '/notifications',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'topics',
        name: 'NotificationsIndex',
        component: () => import('pages/NotificationsIndex.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'create',
        name: 'NotificationsCreate',
        component: () => import('pages/NotificationsCreate.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'all',
        name: 'NotificationsTable',
        component: () => import('pages/NotificationsTable.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },

  {
    path: '/content',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'ContentIndex',
        component: () => import('pages/ContentIndex.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: 'edit/:id?',
        name: 'ContentEdit',
        component: () => import('pages/ContentEdit.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
